export const toTitleCase = (value: string): string => {
    return value.charAt(0).toUpperCase() + value.substring(1).toLowerCase()
}

export function isEmpty(value: string | null | undefined): boolean {
    return value === null || value === undefined || value.trim().length === 0
}

export function formatCurrency(cents: number): string {
    return (cents / 100).toLocaleString('en-NZ', {
        style: 'currency',
        currency: 'NZD',
    })
}
